/*
==========================================
Page02 Visual Search
Popup Controller
==========================================
*/

document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("p02-visual-search");
    const openBtn = document.getElementById("p02-visual-search-btn");
    const closeBtn = document.getElementById("p02-vs-close");
    const fileInput = document.getElementById("p02-vs-file");
    const preview = document.getElementById("p02-vs-preview");

    if (!popup || !openBtn || !closeBtn || !fileInput || !preview) {
        console.log("Visual Search: Missing elements.");
        return;
    }

    console.log("Visual Search Loaded");

    function openPopup() {
        popup.hidden = false;
        document.body.style.overflow = "hidden";
    }

    function closePopup() {
        popup.hidden = true;
        document.body.style.overflow = "";
    }

    openBtn.addEventListener("click", openPopup);

    closeBtn.addEventListener("click", closePopup);

    popup.addEventListener("click", (e) => {
        if (e.target === popup) {
            closePopup();
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closePopup();
        }
    });

    /* ---------- Upload Preview ---------- */

    fileInput.addEventListener("change", () => {

        const file = fileInput.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            preview.innerHTML = `
                <img src="${e.target.result}" alt="Preview">
            `;
        };

        reader.readAsDataURL(file);

    });

});